<template>
    <div class="pw columnNav">
        <div class="columnNavBox" id="navv">
            <template v-for="(item,i) in navList">
                <a :href="item.url" v-if="item.type == 'text'" :key="i">{{item.name}}</a>
                <template v-else>
                    <a href="javascript:;" v-if="showWater" :key="i">{{item.name}}</a>
                    <template v-else-if="item.name == '资讯'">
                        <router-link :to="{path:item.url}" :key="i" :class="{'curr':routePath == '/morenews/16' || routePath == '/morenews/57' || routePath == '/morenews/578' || routePath == '/morenews/676'}">资讯</router-link>
                    </template>
                    <template v-else-if="item.name == '拍卖结果'">
                        <router-link :to="{path:item.url}" :key="i" :class="{'curr':routePath.indexOf('result') != -1}">{{item.name}}</router-link>
                    </template>
                    <template v-else-if="item.name == '拍卖预展'">
                        <router-link :to="{path:item.url}" :key="i" :class="{'curr':routePath.indexOf('preauction') != -1}">{{item.name}}</router-link>
                    </template>
                    <template v-else>
                        <router-link :to="{path:item.url}" :key="i" :class="{'curr':routePath==item.url}">{{item.name}}</router-link>
                    </template>
    
                </template>
            </template>
        </div>
        <div class="main-header-fixed-nav" v-show="showFixedBar">
            <div class="fixed-container">
                <div class="logo">
                    <img src="../../assets/imgs/navLogo.png" alt="" />
                </div>
                <div class="nav">
                    <template v-for="(item,i) in navList.slice(0, 6)">
                        <a :href="item.url" v-if="item.type == 'text'" :key="i">{{item.name}}</a>
                        <template v-else>
                            <a href="javascript:;" v-if="showWater" :key="i">{{item.name}}</a>
                            <template v-else-if="item.name == '资讯'">
                                <router-link :to="{path:item.url}" :key="i" :class="{'curr':routePath == '/morenews/16' || routePath == '/morenews/57' || routePath == '/morenews/578' || routePath == '/morenews/676'}">资讯</router-link>
                            </template>
                            <template v-else-if="item.name == '拍卖结果'">
                                <router-link :to="{path:item.url}" :key="i" :class="{'curr':routePath.indexOf('result') != -1}">{{item.name}}</router-link>
                            </template>
                            <template v-else-if="item.name == '拍卖预展'">
                                <router-link :to="{path:item.url}" :key="i" :class="{'curr':routePath.indexOf('preauction') != -1}">{{item.name}}</router-link>
                            </template>
                            <template v-else>
                                <router-link :to="{path:item.url}" :key="i" :class="{'curr':routePath==item.url}">{{item.name}}</router-link>
                            </template>
    
                        </template>
                    </template>
                    <div ref="more-navs" class="nav-item has-more">
                        <span class="more">更多</span>
                        <p :class="{ active: showMore }" class="icon"></p>
                        <ul v-show="showMore" class="more-list">
                            <li v-for="nav in navList.slice(-5)" :key="nav.name" class="more-list-item">
                                <a :href="nav.url" v-if="nav.type == 'text'">{{nav.name}}</a>
                                <router-link v-else target="_blank" :to="{ path: nav.url }">{{nav.name}}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="search">
                    <el-input placeholder="请输入内容" v-model="selectInput">
                        <!-- <el-select v-model="selectVal" slot="prepend" placement="bottom" placeholder="搜索" :popper-append-to-body="false">
                            <el-option v-for="item in selectData" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select> -->
                        <!-- <el-button slot="append" icon="el-icon-search" @click="gotoSo(selectVal,selectInput)">艺搜</el-button> -->
                        <el-button slot="append" icon="el-icon-search"  @click="gotoSo(selectVal,selectInput)"></el-button>
                    </el-input>
                </div>
                <div class="user">
                    <div class="top-person">
                        <a href="javascript:;" class="beforeLogin" @click="gotoLogin" v-if="uid <=0">登录</a>
                        <el-dropdown v-if="uid > 0">
                            <span class="el-dropdown-link"><img :src="headerImg" alt=""></span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>
                                    <dl class="personHeader">
                                        <dt><img :src="headerImg" alt=""></dt>
                                        <dd>{{personName}}</dd>
                                    </dl>
                                </el-dropdown-item>
                                <el-dropdown-item><a :href="showWater ? 'javascript:;' :'//member.artron.net'">用户中心</a></el-dropdown-item>
                                <el-dropdown-item><a :href="showWater ? 'javascript:;' :'//passport.artron.net/my/chgpasswd/'">修改密码</a></el-dropdown-item>
                                <el-dropdown-item><a href="javascript:;" @click="exit" class="exit">退出登录</a></el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </div>
    
    </div>
    </template>
    
    <script>
    import {
        sentSensors
    } from '@/utils/buriedPoint.js'
    export default {
        name: "columnNav",
        props: ['showWater'],
        data() {
            return {
                showFixedBar: false,
                showMore: false,
                navList: [{
                        name: '首页',
                        type: 'vue',
                        url: '/'
                    },
                    {
                        name: '拍卖预展',
                        type: 'vue',
                        url: '/preauction'
                    },
                    {
                        name: '拍卖结果',
                        type: 'vue',
                        url: '/result'
                    },
                    {
                        name: '拍卖直播',
                        type: 'text',
                        url: this.showWater ? 'javascript:;' : 'https://auction.artron.net/live'
                    },
                    {
                        name: '拍卖黄页',
                        type: 'vue',
                        url: '/brand'
                    },
                    {
                        name:'藏家会员',
                        type: 'text',
                        url:this.showWater ? 'javascript:;':'https://member.artron.net/memCenter/collect?business_id=50001&source_page=6&only=5001'
                    },
                    {
                        name: '得藏',
                        type: 'text',
                        url: this.showWater ? 'javascript:;' : 'https://zxp.artron.net'
                    },
                    {
                        name: '资讯',
                        type: 'vue',
                        url: '/morenews/16'
                    },
                    {
                        name: '对话',
                        type: 'vue',
                        url: '/column'
                    },
                    {
                        name: '市场',
                        type: 'vue',
                        url: '/morenews/577'
                    },
                    {
                        name: '专题',
                        type: 'vue',
                        url: '/topic'
                    },
    
                ],
                routePath: this.$route.path,
                uid: 0,
                headerImg: '',
                personName: '',
                selectData: [{
                        value: 'auction',
                        label: '拍卖',
                    },
                    {
                        value: 'gallery',
                        label: '画廊',
                    },
                    {
                        value: 'news',
                        label: '资讯',
                    },
                    {
                        value: 'artwork',
                        label: '艺术品',
                    },
                    {
                        value: 'exhibit',
                        label: '展览',
                    },
                    {
                        value: 'artist',
                        label: '艺术家',
                    },
                    {
                        value: 'book',
                        label: '图书',
                    },
                ],
                selectVal: 'auction',
                selectInput: '',
            }
        },
        mounted() {
            this.initEvent()
            this.scroll()
            this.uid = this.getCookie('_at_pt_0_') && this.getCookie('_at_pt_0_') > 0 ? this.formatZero(this.getCookie('_at_pt_0_')) : 0;
            this.headerImg = this.getCookie('_at_pt_0_') && this.getCookie('_at_pt_0_') > 0 ? 'https://img12' + '.artimg.net/passport/avatar/' + this.uid.substring(0, 3) + '/' + this.uid.substring(3, 6) + '/' + this.uid.substring(6, 9) + '/150_150.png?t=' + new Date().getTime() : '';
            this.personName = this.getCookie('_at_pt_1_') ? decodeURI(this.getCookie('_at_pt_1_')) : '';
        },
        beforeDestroy() {
            this.removeEvent()
        },
        methods: {
            openMoreNavs() {
                this.showMore = true;
            },
            closeMoreNavs() {
                this.showMore = false;
            },
    
            gotoLogin: function () {
                if (!this.showWater) {
                    window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
                }
            },
            gotoSo(plate, content) {
                // 神策埋点
                let obj = this.selectData.find(e => e.value === plate)
                sentSensors(obj.label, content)
                let gotoUrl = '';
                switch (this.selectVal) {
                    case 'auction':
                        gotoUrl = 'https://artso.artron.net/auction/search_auction.php'
                        break
                    case 'gallery':
                        gotoUrl = 'https://artso.artron.net/gallery/search_gallery.php'
                        break
                    case 'news':
                        gotoUrl = 'https://artso.artron.net/news/search_newslist.php'
                        break
                    case 'artwork':
                        gotoUrl = 'https://artso.artron.net/jewel/search_jewel.php'
                        break
                    case 'exhibit':
                        gotoUrl = 'https://artso.artron.net/exhibit/search_exhibition.php'
                        break
                    case 'artist':
                        gotoUrl = 'https://artso.artron.net/artist/search_artist.php'
                        break
                    case 'book':
                        gotoUrl = 'https://artso.artron.net/ebook/search_book.php'
                        break
                }
                if (this.selectInput.trim()) {
                    if (!this.showWater) {
                        window.open(gotoUrl + '?keyword=' + encodeURIComponent(this.selectInput))
                    }
    
                } else {
                    this.$message('请输入搜索条件');
                }
            },
            formatZero: function (num) {
                if (num.length < 9) {
                    num = (Array(10 - num.length).join(0) + num);
                    return num;
                } else {
                    return num;
                }
            },
            exit: function () {
                if (!this.showWater) {
                    let href = window.location.href
                    if (href.indexOf('artronvip.com') != -1) {
                        let hrefSearch = window.location.search
                        hrefSearch = hrefSearch.substring(0, hrefSearch.indexOf('&token_data='))
                        href = window.location.origin + window.location.pathname + hrefSearch
                        request({
                            method: 'get',
                            url: 'https://member.artronvip.com/memCenter/vip/logout',
                            withCredentials: true
                        }).then(res => {})
                    }
                    window.location.href = '//passport.artron.net/memCenter/logout?redirect=' + encodeURIComponent(href)
                }
            },
            getCookie: function (name) {
                var arr;
                var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (document.cookie.match(reg)) {
                    arr = document.cookie.match(reg);
                    return arr[2];
                } else {
                    return null;
                }
            },
            isInViewPort(element) {
                const viewWidth = window.innerWidth || document.documentElement.clientWidth;
                const viewHeight = window.innerHeight || document.documentElement.clientHeight;
                const {
                    top,
                    right,
                    bottom,
                    left,
                } = element.getBoundingClientRect();
    
                return (
                    top >= 0 &&
                    left >= 0 &&
                    right <= viewWidth &&
                    bottom <= viewHeight
                );
            },
            scroll() {
                let that = this;
                const target = document.querySelector('#navv');
    
                if (this.isInViewPort(target)) {
                    this.showFixedBar = false;
                } else {
                    this.showFixedBar = true;
                }
    
            },
            initEvent() {
                let moreNavs = this.$refs["more-navs"];
                moreNavs.addEventListener("mouseover", this.openMoreNavs, true);
                moreNavs.addEventListener("mouseout", this.closeMoreNavs, true);
                window.addEventListener('scroll', this.scroll, true)
            },
            removeEvent() {
                let moreNavs = this.$refs["more-navs"];
                moreNavs.removeEventListener("mouseover", this.openMoreNavs, true);
                moreNavs.removeEventListener("mouseout", this.closeMoreNavs, true);
                window.removeEventListener('scroll', this.scroll, true)
            },
        }
    }
    </script>
    
    <style lang="scss" scoped>
    .columnNav {
    
        .main-header-fixed-nav {
            min-width: 1180px;
            width: 100%;
            height: 64px;
            box-shadow: 0 4px 10px 0 rgba(0, 0, 0, .1);
            position: fixed;
            top: 0;
            left: 0;
            z-index: 999;
            background: hsla(0, 0%, 100%, .95);
    
            &:after {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                top: 0;
                filter: blur(10px);
                backdrop-filter: blur(10px);
                z-index: -1;
            }
    
            .fixed-container {
                max-width: 1380px;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 0 auto;
                padding: 0px 30px;
    
                .nav-item {
                    height: 100%;
                    font-size: 18px;
                    display: flex;
                    white-space: nowrap;
                    align-items: center;
                    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                    font-weight: bold;
                    color: #262626;
                    line-height: 26px;
                    cursor: pointer;
                    position: relative;
    
                    a {
                        outline: none;
                        text-decoration: none;
                        font-weight: bold;
                        color: #262626;
                    }
    
                    // a:hover {
                    //     color: #329d15 !important;
                    // }
                    // &:after {
                    //     content: "";
                    //     display: block;
                    //     width: 0;
                    //     height: 2px;
                    //     background: #329d15;
                    //     transition: width 0.3s;
                    //     position: absolute;
                    //     bottom: 15px;
                    //     left: 50%;
                    //     transform: translate(-50%, 0);
                    // }
                    &:hover {
                        &:after {
                            width: 100%;
                        }
                    }
    
                    .active {
                        color: #329d15;
    
                        &:after {
                            background: #329d15;
                        }
                    }
    
                    &.has-more {
                        display: flex;
                        align-items: center;
    
                        .more {
                            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                            font-weight: bold;
                            color: #262626;
                            line-height: 26px;
                            cursor: pointer;
                        }
    
                        &:after {
                            display: none;
                        }
    
                        .icon {
                            width: 12px;
                            height: 12px;
                            background: url("../../assets/imgs/arrow-top.png");
                            background-size: 100% 100%;
                            margin-left: 10px;
                            transition: all 0.3s;
                            transform: rotate(180deg);
    
                            &.active {
                                transform: rotate(0deg);
                            }
                        }
    
                        .more-list {
                            width: 100px;
                            background: #fff;
                            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
                            border-radius: 4px;
                            position: absolute;
                            right: 0;
                            top: 49px;
                            overflow: hidden;
    
                            &-item {
                                width: 100%;
                                height: 30px;
                                font-size: 14px;
                                color: #595959;
                                line-height: 22px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-weight: normal;
                                font-family: MicrosoftYaHei;
    
                                a {
                                    width: 100px;
                                    text-align: center;
                                    outline: none;
                                    text-decoration: none;
                                    font-weight: normal;
                                    color: #595959;
                                    font-size: 14px;
                                }
    
                                &:hover {
                                    color: #329d15 !important;
                                    background: #eaf5e7;
                                }
    
                                &:hover a {
                                    color: #329d15 !important;
                                    background: #eaf5e7;
                                }
                            }
                        }
                    }
                }
    
                .logo {
                    width: 231px;
                    height: 45px;
                    margin-right: 50px;
    
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
    
                .nav {
                    flex: 1;
                    height: 100%;
                    margin: 0 25px;
                    width: 100%;
                    height: 64px;
                    margin: 0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
    
                    a {
                        outline: none;
                        text-decoration: none;
                        font-weight: 700;
                        color: #262626;
                        font-size: 18px;
                        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                        line-height: 26px;
                        cursor: pointer;
                        position: relative;
    
                        &:hover {
                            color: #329d15
                        }
                    }
                }
    
                .search {
                    width: 250px;
                    // width: 200px;
                    // height: 38px;
                    margin-left: 30px;
                    // border: 1px solid #D9D9D9;
                    // background-color: #fafafa;
                    // display: flex;
                    // line-height: 38px;
                    // position: relative;
                    /deep/.el-input__inner:focus{
                        border-color: #329d15 !important;
                    }
    
                 
                }
                .search:hover{border-color: #329d15;}
    
                /deep/.el-select-dropdown__item.selected {
                    color: #329d15 !important;
                }
    
                /deep/.el-select-dropdown__item.hover {
                    background-color: #f7f7f7 !important;
                }
    
                .user {
                    height: 100%;
                    margin-left: 30px;
                    display: flex;
                    align-items: center;
    
                    .top-person {
                        .beforeLogin {
                            padding-right: 0;
                            margin-right: 0;
                        }
    
                        .beforeLogin:after {
                            display: none;
                        }
                    }
                }
            }
        }
    
        .columnNavBox {
            display: flex;
            height: 45px;
            border-top: 2px solid #329D15;
            border-bottom: 1px solid #F2F2F2;
            font-size: 16px;
            color: #262626;
            justify-content: space-between;
            align-items: center;
        }
    
        /deep/.el-dropdown {
            color: #fff;
    
            .el-dropdown-link {
                width: 30px;
                height: 30px;
    
                img {
                    width: 30px;
                    height: 30px;
                    object-fit: cover;
                    border-radius: 50%;
                    overflow: hidden;
                    cursor: pointer;
                }
            }
        }
    
        .curr {
            color: #329d15 !important;
        }
    }
    </style>
    